import { IconProps } from "./types";

export const CheckCircleOne = ({ fill = "currentColor", size = 15, style }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 15 15" fill="none" style={style}>
    <path
      d="M5.625 5.50384L7.85103 7.96567C8.05516 8.19142 8.42324 8.17479 8.60474 7.9316L13.125 1.875"
      stroke={fill}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.125 7.5C13.125 10.6066 10.6066 13.125 7.5 13.125C4.3934 13.125 1.875 10.6066 1.875 7.5C1.875 4.3934 4.3934 1.875 7.5 1.875"
      stroke={fill}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
